import { SOCIAL_LINKS } from '../constants';
import { useLanguage } from '../LanguageContext';
import { SOCIAL_ICON_MAP } from './icons/SocialIcons';

export default function FooterSocialLinks() {
  const { t } = useLanguage();

  if (!SOCIAL_LINKS.length) return null;

  return (
    <div className="footer__social">
      <h2 className="footer__heading">{t('footer.socialHeading')}</h2>
      <ul className="footer__social-list" aria-label={t('footer.socialAria')}>
        {SOCIAL_LINKS.map((link) => {
          const Icon = SOCIAL_ICON_MAP[link.id];
          if (!Icon) return null;

          return (
            <li key={link.id}>
              <a
                className="footer__social-link"
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t(link.labelKey)}
              >
                <Icon size={20} />
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
